<template>
    <div class="menu menu-sub menu-sub-dropdown w-250px w-md-300px" data-kt-menu="true">
        <div class="px-7 py-5">
            <div class="fs-5 text-dark fw-bolder">{{ $t('filters.title') }}</div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5 overflow-auto max-h-300px">
            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.id') }}:</label>
                <el-input v-model="filterData.id" oninput="value=value.replace(/[^0-9]/g,'')"/>
            </div>

            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.direction') }}:</label>
                <el-select v-model="filterData.direction_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                    <el-option :value="1" :label="$t('common.transaction.direction.1')"/>
                    <el-option :value="2" :label="$t('common.transaction.direction.2')"/>
                </el-select>
            </div>

            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.status') }}:</label>
                <el-select v-model="filterData.status_id" class="w-100" :placeholder="$t('common.chooseSelect')" multiple collapse-tags clearable>
                    <el-option :value="0" :label="$t('common.transaction.status.0')"/>
                    <el-option :value="1" :label="$t('common.transaction.status.1')"/>
                    <el-option :value="2" :label="$t('common.transaction.status.2')"/>
                    <el-option :value="3" :label="$t('common.transaction.status.3')"/>
                    <el-option :value="4" :label="$t('common.transaction.status.4')"/>
                </el-select>
            </div>

            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.source') }}:</label>
                <el-select v-model="filterData.source_type" class="w-100" :placeholder="$t('filters.transaction.sourceAny')" clearable>
                    <el-option value="MODULE_VEHICLE_WORK_ORDER" :label="$t('common.transaction.sourceModules.MODULE_VEHICLE_WORK_ORDER')"/>
                </el-select>
            </div>

            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.paymentMethod') }}:</label>
                <el-select v-model="filterData.payment_method_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                    <el-option v-for="m in paymentMethods" :key="m.id" :value="m.id" :label="methodLabel(m)"/>
                </el-select>
            </div>

            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.cashRegister') }}:</label>
                <el-select v-model="filterData.cash_register_id" class="w-100" :placeholder="$t('common.chooseSelect')" clearable>
                    <el-option v-for="c in cashRegisters" :key="c.id" :value="c.id" :label="c.name"/>
                </el-select>
            </div>

            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.createdAtMin') }}:</label>
                <DateTimePicker v-model="createdAtMin" type="date" clearable auto-modal
                    :max="createdAtMax || null"
                    :placeholder="$t('common.chooseDate')"/>
            </div>

            <div class="mb-7">
                <label class="form-label fw-bold">{{ $t('filters.transaction.createdAtMax') }}:</label>
                <DateTimePicker v-model="createdAtMax" type="date" clearable auto-modal
                    :min="createdAtMin || null"
                    :placeholder="$t('common.chooseDate')"/>
            </div>
        </div>

        <div class="separator border-gray-200"></div>

        <div class="px-7 py-5">
            <div class="d-flex justify-content-end">
                <button type="reset" v-on:click="onReset" class="btn btn-sm btn-white btn-active-light-primary me-2" data-kt-menu-dismiss="true">{{ $t('btn.reset') }}</button>
                <button type="submit" v-on:click="onFilter" class="btn btn-sm btn-primary" data-kt-menu-dismiss="true">{{ $t('btn.apply') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import transactionService from "@/components/payment/transactionService";
import DateTimePicker from "@/components/common/date-time-picker/DateTimePicker.vue";

export default {
    name: "TransactionFilter",
    components: { DateTimePicker },
    data() {
        return {
            filterData: {},
            createdAtMin: '',
            createdAtMax: '',
        }
    },
    computed: {
        paymentMethods() {
            return transactionService.state.paymentMethods;
        },
        cashRegisters() {
            return transactionService.state.cashRegisters;
        },
    },
    mounted() {
        transactionService.ensurePaymentMethods();
        transactionService.ensureCashRegisters();
    },
    methods: {
        methodLabel(m) {
            const key = 'common.transaction.payment.methodCode.' + m.code;
            const t = this.$t(key);
            return t === key ? m.name : t;
        },
        buildPayload() {
            const data = { ...this.filterData };
            if (this.createdAtMin) data['created_at[min]'] = String(this.createdAtMin).slice(0, 10);
            if (this.createdAtMax) data['created_at[max]'] = String(this.createdAtMax).slice(0, 10);
            return data;
        },
        onReset() {
            this.filterData = {};
            this.createdAtMin = '';
            this.createdAtMax = '';
            this.$emit('onFilter', {});
        },
        onFilter() {
            this.$emit('onFilter', this.buildPayload());
        },
    },
}
</script>
